// extracted by mini-css-extract-plugin
export default {"DeleteWorksetsDialog":"DeleteWorksetsDialog_DeleteWorksetsDialog__fHb6I"};